import gql from 'graphql-tag';

export const SEARCH_COLLABORATORS = gql`
  query SearchCollaborators($query: String, $onlySignedUpUsers: Boolean) {
    loggedIn {
      searchUsers(searchQuery: $query, onlySignedUpUsers: $onlySignedUpUsers) {
        results {
          id
          plexUserId
          name
          email
          picture
          source
        }
      }
    }
  }
`;
